import {
  MODULES_FOR_PARTNER_SUCCESS,
  MODULES_FOR_PARTNER_FAILED,
  RESET_MODULES_FOR_PARTNER,
  LOADING_MODULES_FOR_PARTNER,
  NETWORK_ERROR_MODULES_FOR_PARTNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MODULES_FOR_PARTNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case MODULES_FOR_PARTNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case MODULES_FOR_PARTNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_MODULES_FOR_PARTNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_MODULES_FOR_PARTNER:
      return (state = initialState);
    default:
      return state;
  }
};
